module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toast",
    class: [{
      'toastSuccess': _vm.toast.success
    }, {
      'toast--left-bottom': _vm.leftBottom
    }, {
      'animated fadeInDown': !_vm.leftBottom
    }, {
      'animateFast fadeInUp': _vm.leftBottom
    }],
    style: (_vm.styleObj)
  }, [_c('div', {
    staticClass: "toast-content"
  }, [(_vm.toast.success) ? _c('div', {
    staticClass: "toast__icon toast_icon__success icon-checkmark-circle"
  }) : _vm._e(), _vm._v(" "), (!_vm.toast.success) ? _c('div', {
    staticClass: "toast__icon toast_icon__bell icon-bell"
  }) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.toast.text))])]), _vm._v(" "), _c('div', {
    staticClass: "cross pointer",
    on: {
      "click": function($event) {
        return _vm.$emit('removeNow', _vm.toast.id)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5633e290!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast/Toast.vue
// module id = 1927
// module chunks = 1